import { isBefore, isAfter } from 'date-fns';
import { calculateProgress } from './calculate-progress';

let updateInterval: number | null = null;
const callbacks: Array<() => void> = [];

/**
 * Check if program is currently on TV
 * @param dateStart - Program start date
 * @param dateEnd - Program end date
 * @returns boolean
 */
export const isProgramNowOnTv = (dateStart: Date, dateEnd: Date): boolean => {
    const now = new Date();
    return isBefore(dateStart, now) && isAfter(dateEnd, now);
};

/**
 * Register a callback for program status updates
 * @param callback - Callback function to register
 */
export const registerCallback = (callback: () => void): void => {
    callbacks.push(callback);
};

/**
 * Remove a registered callback
 * @param callback - Callback function to remove
 */
export const unregisterCallback = (callback: () => void): void => {
    const index = callbacks.indexOf(callback);
    if (index > -1) {
        callbacks.splice(index, 1);
    }
};

/**
 * Start the update timer
 */
export const startUpdater = (): void => {
    if (updateInterval !== null) return;

    updateInterval = window.setInterval(() => {
        callbacks.forEach((callback) => callback());
    }, 5000); // Update every 5 seconds
};

/**
 * Stop the update timer
 */
export const stopUpdater = (): void => {
    if (updateInterval !== null) {
        window.clearInterval(updateInterval);
        updateInterval = null;
    }
};

/**
 * Clear all registered callbacks
 */
export const clearCallbacks = (): void => {
    callbacks.length = 0;
};

// Re-export calculateProgress for convenience
export { calculateProgress };
